import { render, staticRenderFns } from "./PeTile.vue?vue&type=template&id=41efd626&"
import script from "./PeTile.vue?vue&type=script&lang=js&"
export * from "./PeTile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports